import { IKhoiActionTypes, eKhoiActionTypeIds } from "../../action-types/category/IKhoiActionType";
import { IKhoiReducer } from "../../reducer-model/category/IKhoiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IKhoiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    khois: []
}
export const khoiReducer = (state: IKhoiReducer=iniState, action: IKhoiActionTypes): IKhoiReducer => {
    switch (action.type) {
        case eKhoiActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case eKhoiActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                khois: action.payload
            }
        case eKhoiActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        default:
            return {
                ...state
            };
    }
}